import { analyticsService } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";
import { LeavingReason } from "@ui/pages/deletion-flow/leaving-reasons-page";

export const sendAnalyticsEventSavePasswordAccount = (): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.SETTINGS,
		action: "saveAccount",
		params: ["password"],
	});

export const sendAnalyticsEventAccountUpdated = (data: string): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.SETTINGS,
		action: "saveAccount",
		params: [data],
	});

export const sendAnalyticsEventEditPassword = (): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.SETTINGS,
		action: "editInformation",
		params: ["password"],
	});

export const sendAnalyticsEventEditProfile = (): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.SETTINGS,
		action: "editInformation",
		params: ["yourInformation"],
	});

export const sendAnalyticsEventAccountDeleted = (leavingReasons: LeavingReason[]): void => {
	analyticsService.trackEvent({
		category: AnalyticsCategory.SETTINGS,
		action: "accountDeleted",
		params: leavingReasons,
	});
};

export const sendAnalyticsEventDeleteAccountCTA = (): void => {
	analyticsService.trackEvent({
		category: AnalyticsCategory.SETTINGS,
		action: "clickCtaDeleteAccount",
		params: [],
	});
};
